import * as React from 'react';
import { connect } from 'react-redux';
import { getHolidays } from '../../redux/actions/holidays';
import {
  Title,
  RouteWrapper,
  HolidayCreateForm,
  HolidayList,
} from '../../components';

interface Props {
  holidays: any;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch(getHolidays());
  }

  render() {
    return (
      <RouteWrapper
        title="Holidays"
        requireAuth
        requirePermission="MANAGE_HOLIDAYS"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/holidays', text: 'Holidays' },
        ]}
      >
        <div className="container">
          <div className="columns">
            <div className="column">
              <Title>Holidays</Title>
              {(!this.props.holidays.isFetching ||
                this.props.holidays.holidays.length > 0) && (
                <HolidayList items={this.props.holidays.holidays} />
              )}
            </div>
            <div className="column is-5">
              <div className="block">
                <HolidayCreateForm />
              </div>
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ holidays }) => ({
  holidays,
});

export default connect(mapStateToProps)(Route);
